module.exports = __webpack_public_path__ + "templates/catalog-filters.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/eshop/templates/catalog-filters.html
// module id = KVpO
// module chunks = 1